module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.94dac78.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Regular/Roboto-Regular.woff
// module id = 8z9N
// module chunks = 17